export default "__VITE_ASSET__O_3WH22T__"